import { useSettingOwFAutomatedCreditCheck } from "@faire/retailer/settings/useSettingOwFAutomatedCreditCheck";
import { route as openWithFaireNMIRoute } from "@faire/web-api/routes/open-with-faire-additional-info";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

export const useIsNMIApplication = () => {
  const { pathname } = useLocation();
  const isOwFAutomatedCreditCheck = useSettingOwFAutomatedCreditCheck();

  const isOnNMIRoute = pathMatchesRoute(pathname, openWithFaireNMIRoute);

  return {
    isNMIApplication: isOnNMIRoute && isOwFAutomatedCreditCheck,
  }
};
